import * as React from 'react';
import './PeopleListPage.scss';

interface Props {
  title: string;
  total?: number;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}

export const PeopleListPageHeader = ({ title, total, children, actions }: Props) => (
  <header className={'schoolPeoplePageHeader' + (actions ? ' schoolPeoplePageHeader--withActions' : '')}>
    <div className="schoolPeoplePageHeader__title">
      <h1>{title}</h1>
      {typeof total === 'number' ? <span>{total.toLocaleString()}</span> : null}
    </div>
    {children ? <div className="schoolPeoplePageHeader__content">{children}</div> : null}
    {actions ? <div className="schoolPeoplePageHeader__actions">{actions}</div> : null}
  </header>
);

PeopleListPageHeader.displayName = 'PeopleListPageHeader';
